import React, { useRef, useState } from "react"
import tw from "twin.macro"
import { GetQuestionsProps, QuestionSort } from "./questions"
import { Platform } from "../../graphql/generated/graphql"
import { useTranslation } from "next-i18next"
import { ReactComponent as FiltersIcon } from "../../assets/profile/filters.svg"
import { DropdownCaret } from "../formElements/dropdownInput"
import { useClickOutside } from "../../utils/hooks/useClickOutside"

interface FilterProps {
  getQuestions: ({ platform, page, sort, videoId }: GetQuestionsProps) => Promise<void>
}
export const Filter = ({ getQuestions }: FilterProps) => {
  const { t } = useTranslation("profile")
  const [platformIndex, setPlatformIndex] = useState(-1)
  const [showPlatforms, setShowPlatforms] = useState(false)
  const platformRef = useRef<HTMLDivElement>(null)
  useClickOutside(platformRef, () => setShowPlatforms(false))

  const platforms = [
    { text: t("filters.discord"), platform: Platform.Discord },
    { text: t("filters.youtube"), platform: Platform.Youtube },
    { text: t("filters.instagram"), platform: Platform.Instagram },
    { text: t("filters.all") },
  ]
  const [sortIndex, setSortIndex] = useState(2)
  const [showPopular, setShowPopular] = useState(false)
  const popularRef = useRef<HTMLDivElement>(null)
  useClickOutside(popularRef, () => setShowPopular(false))
  const populars = [
    { text: t("filters.old"), sort: QuestionSort.Old },
    { text: t("filters.new"), sort: QuestionSort.New },
    { text: t("filters.popular"), sort: QuestionSort.Popular },
  ]

  return (
    <>
      <div tw="relative mr-3" ref={platformRef}>
        <span
          tw="flex justify-between w-[145px] px-3 py-1.5 border-2 border-[#C6C6C6] rounded"
          onClick={() => setShowPlatforms(!showPlatforms)}
        >
          {platformIndex > -1 ? platforms[platformIndex].text : t("filters.filters")}
          <FiltersIcon tw="ml-2" />
        </span>
        <ul
          tw="absolute top-12 z-20 bg-white w-full border-2 border-[#1C1C1C] rounded"
          css={showPlatforms ? tw`inline-block` : tw`hidden`}
        >
          {platforms.map(({ text, platform }, index) => (
            <li
              key={index}
              tw="px-3 py-2 cursor-pointer"
              css={platformIndex === index ? tw`text-[#BC3EF7]` : tw`text-[#1C1C1C]`}
              onClick={async () => {
                setPlatformIndex(index)
                const sort = populars[sortIndex].sort
                await getQuestions({ platform, page: 1, sort })
              }}
            >
              {text}
            </li>
          ))}
        </ul>
      </div>
      <div tw="relative" ref={popularRef}>
        <span
          tw="flex items-center justify-between w-[145px] px-3 py-1.5 border-2 border-[#C6C6C6] rounded"
          onClick={() => setShowPopular(!showPopular)}
        >
          {populars[sortIndex].text}
          <DropdownCaret tw="ml-2" show={showPopular} />
        </span>
        <ul
          tw="absolute top-12 z-20 bg-white w-full border-2 border-[#1C1C1C] rounded"
          css={showPopular ? tw`inline-block` : tw`hidden`}
        >
          {populars.map(({ text, sort }, index) => (
            <li
              key={index}
              tw="px-3 py-2 cursor-pointer"
              css={sortIndex === index ? tw`text-[#BC3EF7]` : tw`text-[#1C1C1C]`}
              onClick={async () => {
                setSortIndex(index)
                const platform = platformIndex > -1 ? platforms[platformIndex].platform : undefined
                await getQuestions({ platform, page: 1, sort })
              }}
            >
              {text}
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}
